import React from 'react';

const Category_grey = () => (
  <svg width="56" height="56" viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="2.5" y="2.5" width="51" height="51" rx="25.5" fill="#EBE9F1"/>
    <rect x="2.5" y="2.5" width="51" height="51" rx="25.5" stroke="white" strokeWidth="5"/>
    <path d="M25.6687 34.0919L19.7002 38.3551C19.1978 38.7139 18.5 38.3548 18.5 37.7374V24.0025C18.5 22.5719 19.6597 21.4121 21.0904 21.4121H30.247C31.6776 21.4121 32.8373 22.5719 32.8373 24.0025V37.7374C32.8373 38.3548 32.1395 38.7139 31.6371 38.3551L25.6687 34.0919Z" stroke="white" strokeWidth="2"/>
    <path d="M24.5 17H32.5C35.2614 17 37.5 19.2386 37.5 22V34" stroke="white" strokeWidth="2" strokeLinecap="round"/>
  </svg>
);

export default Category_grey; 